import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FileDownloadService {

  //if the response type is a blob, or handles blobs, it belongs in this service!!
  constructor(private http: HttpClient) { }

  HandleFileDownload(fileContents : Blob, mimeType : string, fileName : string) {
    let blob = new Blob([fileContents], {type: `application/${mimeType}`});
    let data = window.URL.createObjectURL(blob);
    let link = document.createElement('a');
    link.href = data;
    link.download = fileName;
    link.click();
  }

  DownloadInvoice(invoiceId : number) {
    return this.http.get(environment.baseURl + `/api/invoice/download/${invoiceId}`, { responseType: 'blob' });
  }

  DownloadScreeningBatchTemplate() {
    return this.http.get(environment.baseURl + '/api/screening/batch/template', { responseType: 'blob' });
  }
}
